import { DONATION_ROUTES, ROUTES } from '@/constants';

const DONATION_SEGMENT = DONATION_ROUTES.HOME.pathname.slice(1);

//* proxy가 메인홈을 고기부홈으로 rewrite하면 주소는 `/`로 남는다 — 그려진 라우트 세그먼트로 실제 화면을 가린다
export const toRenderedPathname = (pathname: string, segments: string[]) =>
  pathname === ROUTES.HOME.pathname && segments[0] === DONATION_SEGMENT
    ? DONATION_ROUTES.HOME.pathname
    : pathname;
